import style from './field.module.scss';

export const inputStyle = style.input;
export const inputStyleNoIcon = style.inputNoIcon;
